'use client';

import { CaseStudyHeader } from '@/components/case-study';
import type { GetProjects } from '@/server/api/rest/project/project-repository.ssr';
import type { FC } from 'react';
import { CaseStudyCard } from './case-study-card';

type CaseStudyGridProps = {
  readonly projects: GetProjects;
};

export const CaseStudyGrid: FC<CaseStudyGridProps> = ({ projects }) => {
  const validProjects = projects.filter((p) => p.client).slice(0, 2);

  if (validProjects.length === 0) {
    return null;
  }

  return (
    <CaseStudyHeader>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {validProjects.map((project, i) => (
          <CaseStudyCard
            key={project.id}
            project={project}
            images={project.images}
            slug={project.slug}
            index={i}
            isHero={i === 0}
          />
        ))}
      </div>
    </CaseStudyHeader>
  );
};
